import { Buffer } from 'buffer';

export function helperBase64ToBytes(buff: string): number {
  const buffer = Buffer.from(buff.substring(buff.indexOf(',') + 1));
  return buffer.length;
}
